import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { kisiQueryKeys } from "./kisiQueryKeys";

export function useMutationKisiSaveApiKey({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ apiKey }: { apiKey: string }) =>
      api.kisiApi.saveApiKey(apiKey),
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: kisiQueryKeys.all(),
      });
    },
  });
}
